//main.js file
var SITE_URL = window.location.origin;
var ajax_url = SITE_URL +'/wp-admin/admin-ajax.php';
$(document).ready(function(){

    // Sticky Header
    $(window).scroll(function(){
        var sticky = $('header'),
            scroll = $(window).scrollTop();
        if (scroll >= 100) sticky.addClass('sticky');
        else sticky.removeClass('sticky');
    });

    //Current Year
    if( $( '#copyrightyear' ).length > 0 ) {
      document.getElementById('copyrightyear').appendChild(document.createTextNode(new Date().getFullYear()));
    }

    if (window.matchMedia("(max-width: 1023px)").matches) {
        $('.nav-toggle').click(function(){
            $(this).toggleClass('active');
            $(this).parents('nav').toggleClass('active');
            $(this).parent().parent().parent().next('#main_menu').slideToggle();
            $('html').toggleClass('hide-scroll');
            $('body').toggleClass('hide-scroll');
        });

        $('.nav-wrapper ul li a.nav-link').click(function(){
            $(this).next('ul').slideToggle();
            $(this).toggleClass('active');
            $(this).parent('li').siblings().children('a.nav-link').removeClass('active');
            $(this).parent('li').siblings().children('ul').slideUp();
        });
      } else {
        /* The viewport is greater than 700 pixels wide */
      }

    //Accordion 
    $('.accordion-title').click(function(){
        $(this).toggleClass('active');
        $(this).next().slideToggle();
        $(this).parent().siblings().children('.accordion-title').removeClass('active');
        $(this).parent().siblings().children('.accordion-content').slideUp();
        return false;
    });

    /* Newsletter */
    if( $('.subscribeBtn').length > 0 ) {
        $('.subscribeBtn').click(function() { 
              var container=jQuery(this).closest('div.newsletterForm');
              email = jQuery('.txtEmail',container).val();
              nonce = jQuery(this).data("ajaxnonce");

              if (jQuery.trim(email).length == 0) {
                 jQuery('.errorMsg',container).html('Please Enter Valid Email ID.');
                 return false;
              }

              if (!validateEmailAddress(email)) {
                 jQuery('.errorMsg',container).html('Invalid Email ID.');
                 return false;
              }

              jQuery.ajax({
                  type : 'POST',
                  url  : ajax_url,
                  data : {
                        action: 'ajax_subscribe_newsletter',
                        email: email,
                        security:nonce
                  },              
                  beforeSend: function() {
                      jQuery('.nbw_loader',container).show();
                  },
                  success: function(data, textStatus, XMLHttpRequest) {
                      var decode = jQuery.parseJSON(data);
                      if(decode.flag == 1)
                      {
                          jQuery(".formin",container).fadeOut(600,function(){
                              jQuery(".successMsg",container).html(decode.msg).show();
                          });
                      }
                      else
                      {
                          jQuery('.errorMsg',container).html(decode.msg);
                      }
                      jQuery('.nbw_loader',container).hide();
                  },
                  error: function() {
                      jQuery('.errorMsg'.container).html('Something went wrong. Please try again.');
                      jQuery('.nbw_loader',container).hide();
                  },
              });   
            return false;
        });
    }

    function validateEmailAddress(email)
    {
        var reg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (reg.test(email)){
            return true; 
        }
        else{
            return false;
        }
    }

    //Javascript event to handle lazysizes load
    document.addEventListener('lazybeforeunveil', function(e) {

        //Get lazy load action
        var lazyAction = jQuery(e.target).data('lazyaction');

        //Check if portfolio section
        if( lazyAction == 'featured-portfolios' ) {

            $(".featured-portfolios-section").each( function() {
                var $obj = $(this);
                var limit = $obj.data('limit');   

                jQuery.ajax({
                    url : ajax_url,
                    type : 'post',
                    data : {
                      action : 'get_featured_portfolios',
                      limit : limit
                    },
                    beforeSend: function(){
                      $obj.html('<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 mx-auto animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>');
                    },
                    complete: function(){
                      $obj.find('.svg.animate-spin').remove();
                    },
                    success : function( response ) {
                      $obj.html(response);
                    }
                });
            });
        }
    });

    //Add method for non cyrillic validation
    $.validator.addMethod(
      "nocyrillic",
      function(value, element) {
        var pattern = new RegExp(/[\u0400-\u04FF]/);
        return ! pattern.test(value);
      },
      "Please enter latin characters only."
    );

    //cleared form values
    if( $('form#contact').length > 0 ) {
        $('form#contact')[0].reset();
    }

    //Contact form validation
    $('#contact').validate({
        rules: {
            name: {
                required: true, 
                maxlength:100,
                normalizer: function( value ) {
                   return $.trim( value );
                },
                nocyrillic: true
            },
            w_email: {
                required: true,
                email: true,
                normalizer: function( value ) {
                   return $.trim( value );
                }
            },
            service: {
                required: true
            },
            phone: {
                number: true,
                minlength: 10,
                maxlength: 15
            },
            projdescription: {
                required: true,
                maxlength:1000,
                normalizer: function( value ) {
                    return $.trim( value );
                },
                nocyrillic: true
            }
        },
        /*errorPlacement: function(error,element) {
            return true;
        },
        highlight: function(element) {
            $(element).parent('div').addClass('error');
        },
        unhighlight: function(element) {
            $(element).parent('div').removeClass('error');
        },
        onfocusout: function(element)
        {         
            tmpval = $(element).val().trim();
            if (tmpval == '') {            
                $(element).siblings('.formlabel').removeClass('labelup');
            } else {
                $(element).siblings('.formlabel').addClass('labelup');
            }
            return true;
        }*/
    });

    function trackPageVisit() {
        let history = JSON.parse(sessionStorage.getItem('pageHistory')) || [];
        const currentPage = window.location.href;
        
        if (!history.includes(currentPage)) {
            history.push(currentPage);
            sessionStorage.setItem('pageHistory', JSON.stringify(history));
        }
        
        let referrer = sessionStorage.getItem('landingPageReferrer');
        if (!referrer) {
            referrer = document.referrer || 'direct';
            sessionStorage.setItem('landingPageReferrer', JSON.stringify(referrer));
        }
    
    }
    
    trackPageVisit();
    
    if (document.getElementById('pageHistory')) {
    document.getElementById('pageHistory').value = sessionStorage.getItem('pageHistory');
    }
    if (document.getElementById('landingPageReferrer')) {
    document.getElementById('landingPageReferrer').value = sessionStorage.getItem('landingPageReferrer');
    }

    $(".titbits-items").each( function(){
        var $obj = $(this);
        var limit = $obj.data('limit');
        var tech_ids =  $obj.data('tech');
        
        jQuery.ajax({
            url : ajax_url,
            type : 'post',
            data : {
            action : 'get_titbits_slider',
            limit : limit,
            tech_ids: tech_ids
            },
            beforeSend: function(){
            $obj.html('<span class="text-center">Loading...</span>');
            //$obj.find('.loading-image').show();
            },
            complete: function(){
            $obj.find('.loading-image').hide();
            // Initialize Slick slider
            // $('.titbits-items').slick({
            //   slidesToShow: 1,
            //   slidesToScroll: 1,
            //   autoplay: true,
            //   autoplaySpeed: 0, // For continuous scrolling
            //   speed: 35000, // Adjust this for the desired scrolling speed
            //   cssEase: 'linear',
            //   infinite: true,
            //   variableWidth: true,
            //   arrows: false, // Hide arrows
            //   swipe: true, // Enable swipe if needed
            //   pauseOnHover: false, // Set to false to avoid Slick's default behavior
            // });
            },
            success : function( response ) {
            $obj.html(response);
            }
    
        });
    
    });

});